module.exports = __webpack_public_path__ + "img/game_main_pc_259_off.f654fd6c.png";